import {Component, Inject, OnInit} from '@angular/core';
import {$state} from "app/ajs-upgraded-providers";

@Component({
	standalone: false,
  selector: 'app-settings-general',
  templateUrl: './settings-general.component.html',
  styleUrls: ['./settings-general.component.scss']
})
export class SettingsGeneralComponent implements OnInit {

    constructor(@Inject($state)private state: any) {
        this.state.go("app.settings.general");
    }

  ngOnInit(): void {
  }

}
